<template>
    <a
        :disabled="disabled"
        class="block cursor-pointer py-24 relative trans-ease"
        :class="[ passed ? 'bg-secondary' : 'text-primary']"
        @click="handleClick"
    >
        <transition
            enter-active-class="duration-200 delay-100"
            enter-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="duration-200"
            leave-class="opacity-100"
            leave-to-class="opacity-0">
            <span class="absolute top-0 arrow-right" style="left: 100%; top: 50%; transform: translateY(-50%)" v-if="passed"></span>
        </transition>

        <div class="flex items-center justify-center" :class="[ passed ? 'text-white' : active ? 'text-secondary' : ( disabled ? 'text-primary-20' : 'text-primary') ]">
            <svg-icon :type="tab" class="mr-16" style="width: 2rem; height: 2.4rem;"></svg-icon>
            <div>
                <div class="text-body font-semibold capitalize">{{ $t('campaigns.editor.steps.' + name) }}</div>
                <div class="text-body-sm uppercase" :class="[ passed ? 'text-white' : active ? 'text-secondary' : ( disabled ? 'text-primary-20' : 'text-primary-80') ]">
                    {{ $t('campaigns.editor.step', { from: step, to: 3 }) }}
                </div>
            </div>
        </div>
    </a>
</template>

<script>
import SvgIcon from './SvgIcon.vue';

export default {
    components: {
        'svg-icon': SvgIcon,
    },
    props: {
        active: Boolean,
        tab: String,
        step: String,
        disabled: Boolean,
        passed: Boolean,
        name: String
    },
    methods: {
        handleClick () {
            if (!this.disabled) {
                this.$emit('click');
            }
        }
    }
}
</script>

<style scoped>
.arrow-right {
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;

    border-left: 20px solid #58CC47;
}
</style>
